export default Object.freeze({
  Continuous: 1,
  Yearly: 2,
  Monthly: 3,
  Daily: 4,
});
